// Product Gallery
export function initProductGallery() {
    const productSwiper = document.querySelector('.product-swiper');
    if (!productSwiper) return;

    new Swiper(productSwiper, {
        spaceBetween: 0,
        loop: false,
        navigation: {
            nextEl: '.gallery .next-image',
            prevEl: '.gallery .prev-image',
        },

    });
}


// Quantity Increament & Decrement.
export function initAddToCartQty() {
    const qtyInput = document.querySelector('.product-quantity');
    const increaseBtn = document.querySelector('.increaseQty');
    const decreaseBtn = document.querySelector('.decreaseQty');

    increaseBtn.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value) + 1;
    });

    decreaseBtn.addEventListener('click', function () {
        if (qtyInput.value > 1) {
            qtyInput.value = parseInt(qtyInput.value) - 1;
        }
    });
}

// Related Product slider
export function initSingleProductSwiper() {
    // Wait a brief moment to ensure all elements are rendered
    new Swiper('.related__swiper', {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
            nextEl: '.related__swiper .next-product',
            prevEl: '.related__swiper .prev-product',
        },
        autoHeight: true,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
        // Add these for better compatibility
        observer: true,
        observeParents: true,
        loop: false
    });
}
